import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Project store — tracks which project the user has selected in the
 * multi-project picker. Persists to localStorage so the selection survives
 * page reloads.
 */
export interface ProjectStore {
  selectedProjectId: string | null;
  setSelected: (id: string | null) => void;
  clear: () => void;
}

export const useProjectStore = create<ProjectStore>()(
  persist(
    (set) => ({
      selectedProjectId: null,

      setSelected: (id) => set({ selectedProjectId: id }),

      clear: () => set({ selectedProjectId: null }),
    }),
    {
      name: 'witzy-active-project',
      partialize: (s) => ({ selectedProjectId: s.selectedProjectId }),
    },
  ),
);
